import {Navigation} from "swiper";
import {SlideProps} from "@FRAMEWORK/ui/types/d";
import {EventSlider} from "@COMPONENTS/style/slide";
import {ReactNode} from "react";

interface Props extends SlideProps {
	children: ReactNode;
}

const EventSlide = ({children}: Props) => (
	<EventSlider slidesPerView={3} spaceBetween={15} navigation={true} modules={[Navigation]}>
		{children}
	</EventSlider>
);

export default EventSlide;
